import logo from "../../assets/cbulkops.svg";
import logoIcon from "../../assets/logo-icon.svg";

import * as Css from "./style";

import IconPencil from '@zendeskgarden/svg-icons/src/16/pencil-fill.svg?react';
import IconAdd from '@zendeskgarden/svg-icons/src/16/plus-stroke.svg?react';
// import IconExit from '@zendeskgarden/svg-icons/src/16/exit-stroke.svg?react';
import IconBack from '@zendeskgarden/svg-icons/src/16/chevron-double-left-stroke.svg?react';
import IconHome from '@zendeskgarden/svg-icons/src/16/home-fill.svg?react';

import { useNavigate } from "react-router-dom";
import { useNavbar } from "./useNavbar";

export default function Navbar() {
    const navigate = useNavigate();
    const { isCollapsed, toggleNavbar } = useNavbar();

    return (
        <Css.NavBarContainer $collapsed={isCollapsed}>
            <div>
                <Css.ContainerLogo $collapsed={isCollapsed}>
                    <img
                        src={isCollapsed ? logoIcon : logo}
                        alt="logo bulk-ops"
                    />
                </Css.ContainerLogo>

                <Css.MenuList>
                    <Css.MenuItem $collapsed={isCollapsed} onClick={() => navigate("/")} title={isCollapsed ? "Edição massiva" : undefined}>
                        <IconHome />
                        <span>Inicio</span>
                    </Css.MenuItem>
                    <Css.MenuItem $collapsed={isCollapsed} onClick={() => navigate("/tickets/edit")} title={isCollapsed ? "Edição massiva" : undefined}>
                        <IconPencil />
                        <span>Edição massiva</span>
                    </Css.MenuItem>

                    <Css.MenuItem $collapsed={isCollapsed} onClick={() => navigate("/tickets/create")} title={isCollapsed ? "Criação massiva" : undefined}>
                        <IconAdd />
                        <span>Criação massiva</span>
                    </Css.MenuItem>

                    {/* <Css.MenuItem $collapsed={isCollapsed} title={isCollapsed ? "Logout" : undefined}>
                        <IconExit />
                        <span>Logout</span>
                    </Css.MenuItem> */}
                </Css.MenuList>
            </div>

            <Css.EndNavbarContainer $collapsed={isCollapsed} onClick={toggleNavbar}>
                <IconBack />
                <p>Encolher menu</p>
            </Css.EndNavbarContainer>
        </Css.NavBarContainer>
    );
}
